import React, { useState, useEffect } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import style from './UOMSlider.scss';
import searchStyle from '../search-product/search-product.scss';
import UomProductList from './UomList';
import { connect } from 'react-redux';
import noResultStyle from '../../common/NoResultFound/no-result-found.scss';
import CSSTransition from '../../common/transition/Animation';
import ImageIcons from 'jd-library/ImageIcons';
import useOnScroll from 'jd-library/useOnScroll';
import historyHandler from "jd-library/historyHandler";

const UOMResultList = props => {
	let uomArr = props.uomArr || [];
	let uomScrollRef = React.useRef(null);
	if(props.uomType ==='netweightUOM' && props.searchText){
		uomArr = uomArr.sort((a,b)=> {
			const aIndex = a.displayVal.toLowerCase().indexOf(props.searchText);
            const bIndex = b.displayVal.toLowerCase().indexOf(props.searchText);
            if(aIndex == bIndex) return 0;
			if((aIndex < bIndex && aIndex != -1) || (aIndex > bIndex && bIndex < 0)) return -1;
			if((aIndex > bIndex && bIndex != -1) || (aIndex < bIndex && aIndex < 0)) return 1;
		})
		console.log(uomArr)
	}
	useOnScroll({
		callback : (e,scrollObj) => {
			if (props.deviceData.isMobile){
				return;
			}
			if(scrollObj.currScroll.scrollTop){
				props.setScroll(true);
			}else{
			 	props.setScroll(false);
			}
		},
		element : props.deviceData.isMobile || !uomScrollRef ? null : uomScrollRef,
		deps:[uomScrollRef]
	})
	let popularList = [];
	let otherList = [];
	let resultList = [];
	const closeKeypad = () => {
		// inputRef.current.blur();
		document.getElementById('searchUom').blur();
	};
	const uomLength = uomArr.length;
	if (props.pageType == 'add' && uomLength == 0 && !props.disableCustom) {
		uomArr = [{
			val : props.searchText,
			displayVal : props.searchText
		}]
	}
	if (uomArr.length != 0 && !(props.isEdit && uomArr.length == 1 && !uomArr[0]['singular'])) {
		uomArr.forEach(cur => {
			const clickHandler = e => {
				props.onSelectUOM(e, cur);
				props.closeSlider();
			};
			let uomProductList = (
				<UomProductList
					uom={cur.displayVal}
					onClick={clickHandler}
					searchText={props.searchText}
				/>
			);
			if(cur.val == 'stds' && props.priceModal) {
				return;
			}
			if (cur.isPopular) {
				if ((!props.fromAddPrice && !(props.isHideStds && cur.val == 'stds')) || (props.fromAddPrice && !(props.fromAddPricePriceRange && cur.val == 'stds')) ){
					popularList.push(uomProductList)
				}
			} else {
				otherList.push(uomProductList);
			}
		});
		if(props.searchText == ''){
			if (popularList.length) {
				popularList = (
					<>
						<div className={style['prod-head']}>POPULAR UNITS</div>
						{popularList}
					</>
				);
			}
			if (otherList.length) {
				otherList = (
					<>
						{uomLength ? <div className={style['prod-head']}>OTHER UNITS</div> : null}
						{otherList}
					</>
				);
			}
		}
		resultList.push(popularList);
		resultList.push(otherList)
		return (
			<div className={`${style['result-holder']}`} onTouchMove={closeKeypad} body-scroll-lock-ignore='true'>
				<div className={style['result-list']} ref={uomScrollRef}>
					{resultList}
				</div>
			</div>
		);
	} else {
		return (
			<div
				className={
					`${noResultStyle['no-result-container']} ${style['no-result-holder']}`
				}
				onTouchMove={closeKeypad}
			><div className = {`${
				(props.inputFocus && props.deviceData.isIphone) ? style['no-result-fixed'] : ''
			} ${style['no-result-product']}`} >
				<img
					src={props.isEdit? ImageIcons.NO_SEARCH: 'https://image1.jdomni.in/jdomni_email/NoProductFound_1911281253.png'}
					className={noResultStyle['no-result-img']}
				/>
				<h3 className={noResultStyle['no-result-heading']}>
					No Results Found
				</h3>
				</div>
			</div>
		);
	}
};

const UOMSlider = React.forwardRef((props, ref) => {
	const [searchText, setSearchText] = useState('');
	const inputRef = React.createRef();
	const [isScrolled, setScroll] = useState(false);
	const [inputFocus, setInputFocus] = useState(true);
	//console.log(props.deviceData)
	const closeSlider = () => {
		window.history.back();
		setSearchText('');
	};

	const onValChange = e => {
		let inputVal = e ? e.currentTarget.value : '';
		setSearchText(inputVal);
		if (!e) {
			inputRef.current.focus();
		}
	};

	const getFilteredResult = result => {
		if (!searchText) {
			return result;
		}
		return result.filter(cur => {
			var newSynonym = '|$$|' + cur.synonym.toLowerCase() + '|$$|';
			let returnFlag = true;
			if (
				searchText &&
				newSynonym.indexOf(searchText.toLowerCase()) == -1
			) {
				returnFlag = false;
			}
			return returnFlag;
		});
	};
	const result = getFilteredResult(props.uomList || []);
	useEffect(() => {
		if (inputRef.current != null) {
			inputRef.current.focus();
		}
	}, []);
	useEffect(() => {
		setSearchText('');
	}, [props.uomType]);
	const isMobile = props.deviceData.isMobile ;
	return (
		<SliderWrapper
			onHidden={show => {
				props.showHideSlider && props.showHideSlider(show);
				props.onHidden && props.onHidden();
			}}
			header={isMobile ? null : {
				heading: 'Select Unit',
				variant : 'secondary',
				hideLeftIcon: !props.showAddEditProduct,
				headingClass: style['uom-slider-header-title'],
				className: style['uom-slider-header'],
				rightIcons: [
					{
						className: 'icon-HDRcross',
						onClick: e => {
							if(props.showAddEditProduct){
								historyHandler.closeAll();
							}else{
								historyHandler.closeCurrent();
							}
						}
					}
				]
			}}
			slider = {{
				className : style['search-uom-slider']
			}}
			enableHeader={!isMobile}
		>
			{props.uomType ? (
				<div
					className={
						searchStyle['search-holder'] +
						' ' +
						style['search-uom-holder']
						+ ' ' + (isMobile ? '': style['isWeb'])
					}
				>
					<div className={`${searchStyle['search-header']} ${isScrolled ? ' scrolled': ''}`}>
						<div
							className={searchStyle['icon-holder']}
							onClick={() => isMobile && closeSlider()}
						>
							<i
								className={`${searchStyle['back-icon']}  icon-${isMobile ? 'HDRback' : 'HDRsearch'}`}
							/>
						</div>
						<input
							ref={inputRef}
							type='text'
							className={searchStyle['search-input']}
							placeholder='Search Unit'
							onChange={e => onValChange(e)}
							value={searchText}
							autoFocus
							autocomplete='off'
							id='searchUom'
							onFocus={() => {setInputFocus(true);}}
							onBlur={() => {setInputFocus(false);}}
						/>
						{searchText && (
							<AnimateOnHover
								className={searchStyle['icon-holder']}
								onClick={() => onValChange()}
							>
								<i
									className={`${searchStyle['clear-icon']} icon-HDRcross`}
								></i>
							</AnimateOnHover>
						)}
					</div>
					<CSSTransition>
						<UOMResultList
							uomArr={result}
							onSelectUOM={props.onSelectUOM}
							closeSlider={closeSlider}
							searchText={searchText}
							deviceData ={props.deviceData}
							inputFocus = {inputFocus}
							isEdit={props.itemInfo.isEdit}
							setScroll={setScroll}
							pageType = {props.pageType}
							disableCustom={props.disableCustom}
							uomType={props.uomType}
							priceModal={props.priceModal}
							isHideStds={props.isHideStds}
							fromAddEditProduct={props.fromAddEditProduct}
							fromAddPrice={props.fromAddPrice}
							fromAddPricePriceRange={props.fromAddPricePriceRange}
						/>
					</CSSTransition>
				</div>
			) : null}
		</SliderWrapper>
	);
});

const mapStateToProps = (state, props) => {
	const uomType = props.uomType;
	const finalUomList = props.isHideStds ? state.uom[uomType]?.filter((l) => l.value != 'stds') : props.isProduct ? state.uom[uomType]?.filter((l) => !['Sess','stds','Visit'].includes(l.val)) : state.uom[uomType];
	const uomList = uomType && uomType != 'both' ? finalUomList : uomType && uomType == 'both' ? [...state.uom.productUOM,...state.uom.serviceUOM] : [];
	const uniqueList = uomType && uomType != 'both' ? uomList : Object.values(
		uomList.reduce((a, c) => {
		  a[c.displayVal + '|' + c.isPopular] = c;
		  return a
		}, {}));
	return {
		uomList: props.psvUOM || uniqueList,
		itemInfo: state.items.itemInfo,
		deviceData: state.deviceData,
		showAddEditProduct: state.products.showAddEditProduct,
		isHideStds: props.isHideStds,
		fromAddEditProduct: props.fromAddEditProduct,
		fromAddPrice: props.fromAddPrice,
		fromAddPricePriceRange: props.fromAddPricePriceRange,
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	UOMSlider
);
